import axios from "axios";

import React, { useContext, useState } from "react";
import { StoreContext } from "../../context/StoreContext";
import UserContext from "../../context/UserContext";
import CartContext from "../../context/CartContext";

import { isContatNo, isEmpty, isNotPostiveNumber, stateInfo, isEmail } from "../../util/validate";
import { FiArrowLeft } from "react-icons/fi";
import { Box, Typography, Divider, Paper, Button } from "@mui/material";
import OrderSuccessPopup from "../popup/OrderSuccessPopup";
import { API_CHECKOUT_SAVE, API_BUILDER_CHECKOUT_SAVE, STORE_URL } from "../../api/api";


const UserForm = ({ onOrderConfirmed, setPopup }) => {
  const userCtx = useContext(UserContext);
  const { data } = useContext(StoreContext);
  const storeDetails = data.store_master;
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const cartCtx = useContext(CartContext);
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);
  const [forceShowAll, setForceShowAll] = useState(false);

  const handleOrderSuccess = () => {
    cartCtx.clearCart();
    userCtx.updateUser(user);
    setShowSuccessPopup(true);
  };
  const handleCancel = () => {
    userCtx.goToHomePage();
  }

  const total = cartCtx.items.reduce(
    (acc, cur) => acc + parseFloat(cur.price) * cur.qty,
    0
  );
  const toPay = cartCtx.items.reduce(
    (acc, cur) =>
      acc + parseFloat(cur.specialprice ? cur.specialprice : cur.price) * cur.qty,
    0
  );
  const packingCharge = 10;
  const overallTotal = toPay + packingCharge;
  const [user, setUser] = useState({
    name: userCtx.userInfo.name || "",
    contact: userCtx.userInfo.contact || "",
    email: userCtx.userInfo.email || "",
    state: userCtx.userInfo.state || "",
    state_id: userCtx.userInfo.state_id || "",
    city: userCtx.userInfo.city || "",
    address: userCtx.userInfo.address || "",
    country: "India"
  });
  const statesInfo = stateInfo(storeDetails);
  const [showDropdown, setShowDropdown] = useState(false);

  const filteredStates =
    forceShowAll
      ? statesInfo
      : user.state.trim().length > 0
        ? statesInfo.filter((zone) =>
          zone.name.toLowerCase().includes(user.state.toLowerCase())
        )
        : statesInfo || [];

  const [error, setError] = useState({
    name: false,
    contact: false,
    city: false,
    address: false,
  });

  const handleInputChange = (identifier, value, label) => {

    if (identifier === "state") {
      const selectedState = statesInfo.find((state) => state.name === value);
      setUser((prev) => ({
        ...prev,
        state: value,
        state_id: value || "",
      }));
      setError((prev) => ({
        ...prev,
        state: !selectedState,
      }));
    } else {
      setUser((prev) => ({
        ...prev,
        [identifier]: value,
      }));
    }

    if (identifier === "city" && value === "") {
      setError((prev) => ({
        ...prev,
        city: true,
      }));
    } else if (identifier === "city") {
      setError((prev) => ({
        ...prev,
        city: false,
      }));
    }

    if (identifier === "address" && value === "") {
      setError((prev) => ({
        ...prev,
        address: true,
      }));
    } else if (identifier === "address") {
      setError((prev) => ({
        ...prev,
        address: false,
      }));
    }

    if (identifier === "contact" && isContatNo(value)) {
      setError((prev) => ({
        ...prev,
        [identifier]: true,
      }));
    } else if (identifier === "email" && value !== "" && !isEmail(value)) {
      setError((prev) => ({
        ...prev,
        [identifier]: true,
      }));
    } else if (value === "" && identifier !== "email") {
      setError((prev) => ({
        ...prev,
        [identifier]: true,
      }));
    } else {
      setError((prev) => ({
        ...prev,
        [identifier]: false,
      }));
    }

  };

  const handleSubmitUser = (e) => {
    e.preventDefault();
    userCtx.updateUser(user);
    userCtx.goToOrderPage();
  };

  const handleGoBack = () => {
    userCtx.goToHomePage();
  };

  const handleClick = () => {
    if (cartCtx.items.length === 0) {
      setError({
        status: true,
        message: "Your cart is empty. Please add items before placing an order.",
      });
      return;
    }

    if (onOrderConfirmed) {
      onOrderConfirmed();
    }
  };


  const handleConfirmOrderInBuilder = async () => {
    const validationErrors = {
      name: isEmpty(user.name),
      contact: isContatNo(user.contact),
      city: isEmpty(user.city),
      address: isEmpty(user.address),
      state: isEmpty(user.state) || (storeDetails[0].zones && isEmpty(user.state_id)),
      email: user.email !== "" && !isEmail(user.email)
    };

    setError(validationErrors);

    if (Object.values(validationErrors).some(Boolean)) {
      return;
    }

    setIsSubmitLoading(true);
    var cartItems = cartCtx.items;
    var newCartItems = [];
    for (var i = 0; i < cartItems.length; i++) {
      var newProduct = {};
      newProduct.product_id = cartItems[i].id;
      newProduct.quantity = cartItems[i].qty;
      newCartItems.push(newProduct);
    }

    var customerAddress = {};
    customerAddress.firstname = userCtx.userInfo.name;
    customerAddress.lastname = userCtx.userInfo.name;
    customerAddress.email = userCtx.userInfo.email;
    customerAddress.telephone = userCtx.userInfo.contact;
    customerAddress.phone = userCtx.userInfo.contact;
    customerAddress.city = userCtx.userInfo.city;
    customerAddress.address = userCtx.userInfo.address;;
    customerAddress.postcode = "postcode";
    customerAddress.address_1 = userCtx.userInfo.location;
    customerAddress.zone_id = userCtx.userInfo.state_id;
    customerAddress.country_id = userCtx.userInfo.country;

    var shippingInfo = {};
    shippingInfo.shipping_method = "free.free";
    shippingInfo.comment = "";

    var paymentInfo = {};
    paymentInfo.payment_method = "qr_payment";
    paymentInfo.agree = 1;
    paymentInfo.comment = "";

    const dataFormat = {
      products: newCartItems,
      address: customerAddress,
      shipping: shippingInfo,
      payment: paymentInfo,
      domain: STORE_URL,
    };

    const mycallback = JSON.stringify(dataFormat);
    await axios
      .post(API_BUILDER_CHECKOUT_SAVE, mycallback, { headers: { 'Content-Type': 'application/json' } })
      .then(function (response) {
        console.log(response.data.message);
        setPopup(true);
      })
      .catch(function (error) {
        setError({
          status: true,
          message: error.message,
        });
      });
    setIsSubmitLoading(false);
  };

  const handleConfirmOrder = async () => {
    const validationErrors = {
      name: isEmpty(user.name),
      contact: isContatNo(user.contact),
      city: isEmpty(user.city),
      address: isEmpty(user.address),
      state: isEmpty(user.state),
      email: user.email !== "" && !isEmail(user.email)
    };

    setError(validationErrors);

    if (Object.values(validationErrors).some(Boolean)) {
      return;
    }

    setIsSubmitLoading(true);
    var cartItems = cartCtx.items;
    var newCartItems = [];
    for (var i = 0; i < cartItems.length; i++) {
      var newProduct = {};
      newProduct.product_name = cartItems[i].productname;
      newProduct.price = cartItems[i].specialprice
        ? cartItems[i].specialprice
        : cartItems[i].price;
      newProduct.quantity = cartItems[i].qty;
      newProduct.sku = cartItems[i].code;
      newProduct.total =
        parseFloat(
          cartItems[i].specialprice
            ? cartItems[i].specialprice
            : cartItems[i].price
        ) * cartItems[i].qty.toFixed(2);
      newCartItems.push(newProduct);
    }
    const dataFormat = {
      type: "order",
      customer_fname: userCtx.userInfo.name,
      customer_lname: "",
      customer_phone: userCtx.userInfo.contact,
      customer_email: userCtx.userInfo.email,
      customer_address: userCtx.userInfo.address,
      customer_city: userCtx.userInfo.city,
      customer_state: userCtx.userInfo.state,
      product: newCartItems,
    };

    const mycallback = JSON.stringify(dataFormat);
    await axios
      .post(API_CHECKOUT_SAVE, mycallback, { headers: { 'Content-Type': 'application/json' } })
      .then(function (response) {
        console.log("CHECKOUT SAVE URL:", API_CHECKOUT_SAVE);

        console.log(response.data.message);
        setPopup(true);
      })
      .catch(function (error) {
        console.log("CHECKOUT SAVE URL:", API_CHECKOUT_SAVE);

        setError({
          status: true,
          message: error.message,
        });
      });
    setIsSubmitLoading(false);
  };
  return (
    <form className="contact-popup">

      {/* State */}
      <div className="form-group" style={{ position: "relative" }}>
        <label htmlFor="customerState">State</label><span style={{ color: 'red' }}>*</span>
        <input
          id="customerState"
          type="text"
          className="form-control"
          placeholder="State"
          value={user.state}
          onChange={(e) => {
            setForceShowAll(false);
            handleInputChange("state", e.target.value);
          }}
          onFocus={() => {
            setForceShowAll(true);   
            setShowDropdown(true);
          }}
          onBlur={() => {
            setShowDropdown(false);
            setForceShowAll(false);   
          }}
          autoComplete="off"
        />
        {showDropdown && filteredStates.length > 0 && (
          <ul className="autocomplete-list">
            {filteredStates.map((zone) => (
              <li
                key={zone.zone_id}
                onMouseDown={() => handleInputChange("state", zone.name)}
                onTouchStart={() => handleInputChange("state", zone.name)}
                className="autocomplete-item"
              >
                {zone.name}
              </li>
            ))}
          </ul>
        )}
        {error.state && <div className="input-error">Select a valid state</div>}
      </div>

      {/* City */}
      <div className="form-group">
        <label htmlFor="customerCity">City</label><span style={{ color: 'red' }}>*</span>
        <input
          id="customerCity"
          type="text"
          className="form-control"
          placeholder="City"
          onChange={(e) => handleInputChange("city", e.target.value, "0")}
          value={user.city}
        />
        {error.city && <div className="input-error">Enter your city</div>}
      </div>

      {/* Name */}
      <div className="form-group">
        <label htmlFor="customerName">Name</label><span style={{ color: 'red' }}>*</span>
        <input
          id="customerName"
          type="text"
          className="form-control"
          placeholder="Customer Name"
          onChange={(e) => handleInputChange("name", e.target.value, "0")}
          value={user.name}
        />
        {error.name && <div className="input-error">Enter your name</div>}
      </div>

      {/* Contact */}
      <div className="form-group">
        <label htmlFor="contactNumber">Mobile Number</label><span style={{ color: 'red' }}>*</span>
        <input
          id="contactNumber"
          type="number"
          className="form-control"
          placeholder="Contact Number"
          onChange={(e) => handleInputChange("contact", e.target.value, "0")}
          onKeyDown={(e) => isNotPostiveNumber(e.key) && e.preventDefault()}
          value={user.contact}
          onWheel={(e) => e.target.blur()}
        />
        {error.contact && <div className="input-error">Enter valid contact number</div>}
      </div>

      {/* Email */}
      <div className="form-group">
        <label htmlFor="customerEmail">Email</label>
        <input
          id="customerEmail"
          type="text"
          className="form-control"
          placeholder="Customer Email"
          onChange={(e) => handleInputChange("email", e.target.value, "0")}
          value={user.email}
        />
        {error.email && <div className="input-error">Enter valid Email ID</div>}
      </div>

      {/* Address */}
      <div className="form-group">
        <label htmlFor="customerAddress">Address</label><span style={{ color: 'red' }}>*</span>
        <textarea
          id="customerAddress"
          className="form-control address-input"
          placeholder="Enter your address"
          onChange={(e) => handleInputChange("address", e.target.value, "0")}
          value={user.address}
        />
        {error.address && <div className="input-error">Enter valid address</div>}
      </div>

      <div style={{ background: 'linear-gradient(90deg, #FF2200 0%, #FF8C00 100%)', paddingBottom: '30px' }}>

        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            padding: '25px 33px 5px 33px'
          }}
        >
          <Typography
            sx={{ fontSize: "17px", fontWeight: 500 }}
          >
            Sub Total
          </Typography>
          <Typography
            sx={{
              fontSize: "1.125rem",
            }}
          >
            ₹ {toPay.toFixed(2)}
          </Typography>
        </Box>

        <Box sx={{ display: "flex", justifyContent: "space-between", padding: '0px 33px 5px 33px' }}>
          <Typography sx={{ fontSize: "17px", fontWeight: 500 }}>
            Packing Charges
          </Typography>
          <Typography sx={{ fontSize: "1.1rem", fontWeight: 500 }}>
            ₹ {packingCharge.toFixed(2)}
          </Typography>
        </Box>
        <Box sx={{ display: "flex", justifyContent: "space-between", padding: '0px 33px 5px 33px' }}>
          <Typography sx={{ fontSize: "17px", fontWeight: 500 }}>
            Overall Amount
          </Typography>
          <Typography sx={{ fontSize: "1.1rem", fontWeight: 500 }}>
            ₹ {overallTotal.toFixed(2)}
          </Typography>
        </Box>
        <Button
          type="button"
          className="custom-btn"
          onClick={(storeDetails[0].internal_domain && handleConfirmOrderInBuilder) || handleConfirmOrder}
          // onClick={(e) => handleOrderSuccess(e)}
          disabled={isSubmitLoading}
          style={{
            background: '#1EB200',
            color: 'white',
            padding: '12px 15px',
            margin: '10px auto',
          }}

        >
          CONFIRM ORDERS
        </Button>
        <button
          className="cancel-btn"
          onClick={handleCancel}
          sx={{
            background: '#fff',
            color: 'white',
            borderRadius: '25px',
            padding: '12px 15px',
            fontWeight: '500',
            fontSize: '1rem',
            textTransform: 'uppercase',
            boxShadow: '0 5px 15px rgba(0, 0, 0, 0.2)',
            margin: '10px auto',
          }}
        >
          Cancel
        </button>
      </div>
      {
        showSuccessPopup && (
          <OrderSuccessPopup onClose={() => setShowSuccessPopup(false)} />
        )
      }

    </form >

  );
};

export default UserForm;